import { getCookieDomain } from '@/utils/cookie'

export const useApolloToken = () => {
  const tokenCookie = useCookie('apollo-token', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const expiresCookie = useCookie('apollo-expires', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const userIdCookie = useCookie('ota-conv-context', {
    path: '/',
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const jtwCookie = useCookie('jwt_hp', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const token = computed(() => tokenCookie?.value || '')
  const expires = computed(() => expiresCookie?.value || '')
  const userId = computed(() => userIdCookie?.value || '')

  const setToken = (value: string | null) => {
    tokenCookie.value = value
  }

  const setExpires = (value: string | null) => {
    expiresCookie.value = value
  }

  const setUserId = (value: string | null) => {
    userIdCookie.value = value
  }

  const clearAllCookies = () => {
    // Clear cookies with domain
    tokenCookie.value = null
    expiresCookie.value = null
    userIdCookie.value = null
    jtwCookie.value = null

    // Also clear cookies without domain (for migration/cleanup)
    const tokenNoDomain = useCookie('apollo-token')
    tokenNoDomain.value = null
    const expiresNoDomain = useCookie('apollo-expires')
    expiresNoDomain.value = null
    const userIdNoDomain = useCookie('ota-conv-context')
    userIdNoDomain.value = null
    const jwtNoDomain = useCookie('jwt_hp')
    jwtNoDomain.value = null
  }

  return {
    tokenCookie,
    token,
    setToken,
    expiresCookie,
    expires,
    setExpires,
    userIdCookie,
    userId,
    setUserId,
    clearAllCookies
  }
}
